// extracted by mini-css-extract-plugin
module.exports = {"search":"D_cv","input":"D_cw","search-icon":"D_cx","searchIcon":"D_cx"};